import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Hero from "@/components/sections/Hero";
import TrustBar from "@/components/sections/TrustBar";
import Programs from "@/components/sections/Programs";
import Manifesto from "@/components/sections/Manifesto";
import WhyUs from "@/components/sections/WhyUs";
import TherapiesMarquee from "@/components/sections/TherapiesMarquee";
import InteractiveJourney from "@/components/sections/InteractiveJourney";
import RecoveryJourney from "@/components/sections/RecoveryJourney";
import RecoveryArc from "@/components/sections/RecoveryArc";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import Faq from "@/components/sections/Faq";
import Admissions from "@/components/sections/Admissions";
import InsuranceProviders from "@/components/sections/InsuranceProviders";
import FeaturedOn from "@/components/sections/FeaturedOn";
import useSEO from "@/hooks/useSEO";

const Home = () => {
  const location = useLocation();
  useSEO({
    title: "Inpatient Drug & Alcohol Rehab in Toronto — New Beginnings Recovery Home",
    description:
      "Licensed inpatient drug & alcohol addiction treatment centre near the Scarborough Bluffs, Toronto. 28-day residential rehab, 24/7 supervision with on-call medical care, private-pay & GreenShield direct-billing. Same-day admission.",
    keywords: "inpatient rehab Toronto, drug alcohol rehab Toronto, addiction treatment centre Toronto, GreenShield rehab, private rehab Ontario, Scarborough Bluffs rehab",
    canonical: "https://newbeginningsrecovery.ca/",
  });

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [location]);

  return (
    <div data-testid="home-page" className="bg-sand">
      <Navbar />
      <main>
        <Hero />
        <FeaturedOn />
        <Programs />
        <TrustBar />
        <Manifesto />
        <InteractiveJourney />
        <WhyUs />
        <RecoveryJourney />
        <TherapiesMarquee />
        <Gallery />
        <Testimonials />
        <InsuranceProviders />
        <Faq />
        <RecoveryArc />
        <Admissions />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
